import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { announcementApi } from "../api/announcementApi";
import { PAGINATION } from "../constants/common";

export const useAnnouncements = (params) => {
  const queryKey = ["/announcements", params];
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => await announcementApi.getAll(params),
  });

  const create = useMutation({
    mutationFn: async (body) => await announcementApi.create(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const update = useMutation({
    mutationFn: async ({ id, body }) => await announcementApi.update(id, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const remove = useMutation({
    mutationFn: async (id) => await announcementApi.remove(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const togglePin = useMutation({
    mutationFn: async (id) => await announcementApi.togglePin(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination || PAGINATION,
    total: data?.pagination?.total || 0,
    loading: isLoading,
    error,
    create,
    update,
    remove,
    togglePin,
  };
};

export const useAnnouncement = (id) => {
  const queryKey = ["/announcement", id];
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => await announcementApi.getById(id),
    enabled: !!id && id !== "create",
  });

  const create = useMutation({
    mutationFn: async (body) => await announcementApi.create(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const update = useMutation({
    mutationFn: async ({ id, body }) => await announcementApi.update(id, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  return {
    data,
    loading: isLoading,
    error,
    create,
    update,
  };
};
